var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"x-small":"","label":"","outlined":"","color":_vm.option.color,"alvqa":_vm.alvqa + '-chip-outcome-' + _vm.outcome}},[_c('span',{staticClass:"text--primary"},[_vm._v(_vm._s(_vm.$t(_vm.option.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }